import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MainService } from 'BaseServices/main-service';
import { EquipmentDetailDTO } from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';
import { HttpClient } from '@angular/common/http';
import { HeaderService } from 'BaseServices/header.service';

@Component({
  selector: 'app-equipment-mobile-site',
  standalone: true,
  imports: [CommonModule, MatTabsModule, RouterModule],
  templateUrl: './equipment-mobile-site.component.html',
  styleUrl: './equipment-mobile-site.component.css',
})
export class EquipmentMobileSiteComponent implements OnInit, OnDestroy {
  protected tabs = [
    { label: 'Home', route: './home' },
    { label: 'Info', route: './info' },
    { label: 'Docs', route: './docs' },
    { label: 'Udlån', route: './borrow' },
    { label: 'Kontrol status', route: './controlstatus' },
    { label: 'Udfør kontrol', route: './performcontrol' },
  ];

  protected selectedTabIndex = 0;

  equipment: EquipmentDetailDTO | null = null;
  loading = true;

  get activeTab(): string {
    return this.router.url.split('/').pop() || 'home';
  }

  constructor(
    private route: ActivatedRoute,
    private mainService: MainService,
    private router: Router,
    private http: HttpClient,
    private headerService: HeaderService,
  ) {}

  ngOnInit(): void {
    this.headerService.setHideHeader(true);
    const token = this.route.snapshot.queryParamMap.get('token');

    // Gammel QR-url: /BorrowEquipment.aspx?token=1637
    if (token) {
      this.http
        .get<EquipmentDetailDTO>(`/api/Equipment/ByToken?token=${token}`)
        .subscribe({
          next: (eq) => {
            const id = Number(eq?.id ?? 0);

            if (id > 0) {
              this.router.navigate(['/udstyr/kontrollerudstyr', id, 'home']);
            } else {
              console.error('No equipment found for token');
              this.loading = false;
            }
          },
          error: (err) => {
            console.error('Could not resolve token', err);
            this.loading = false;
          },
        });

      return;
    }

    // Ny URL: /kontrollerudstyr/:id
    const id = Number(this.route.snapshot.paramMap.get('id'));

    if (!id || id <= 0) {
      console.error('Invalid equipment id');
      this.loading = false;
      return;
    }

    this.mainService.get<EquipmentDetailDTO>('Equipment', id).subscribe({
      next: (eq) => {
        this.equipment = eq;
        this.loading = false;
      },
      error: (err) => {
        console.error('Could not load equipment', err);
        this.loading = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.headerService.setHideHeader(false);
  }
}
